import React from 'react';

const DragContext = React.createContext();

export default DragContext;